"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  isViewContainer: true,
  isSessionModel: true,
  isSessionModelWithConfigEditing: true,
  isSessionWithAddTracks: true,
  isSessionModelWithWidgets: true,
  isSessionWithSessionPlugins: true,
  isSelectionContainer: true,
  isViewModel: true,
  isTrackModel: true,
  isDisplayModel: true,
  isTrackViewModel: true,
  isAppRootModel: true,
  isAbstractMenuManager: true,
  isUriLocation: true,
  AuthNeededError: true,
  RetryError: true,
  isAuthNeededException: true,
  isRetryException: true
};
exports.isViewContainer = isViewContainer;
exports.isSessionModel = isSessionModel;
exports.isSessionModelWithConfigEditing = isSessionModelWithConfigEditing;
exports.isSessionWithAddTracks = isSessionWithAddTracks;
exports.isSessionModelWithWidgets = isSessionModelWithWidgets;
exports.isSessionWithSessionPlugins = isSessionWithSessionPlugins;
exports.isSelectionContainer = isSelectionContainer;
exports.isViewModel = isViewModel;
exports.isTrackModel = isTrackModel;
exports.isDisplayModel = isDisplayModel;
exports.isTrackViewModel = isTrackViewModel;
exports.isAppRootModel = isAppRootModel;
exports.isAbstractMenuManager = isAbstractMenuManager;
exports.isUriLocation = isUriLocation;
exports.isAuthNeededException = isAuthNeededException;
exports.isRetryException = isRetryException;
exports.RetryError = exports.AuthNeededError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _mobxStateTree = require("mobx-state-tree");

var _util = require("./util");

Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _util[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _util[key];
    }
  });
});

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function isViewContainer(thing) {
  return (0, _mobxStateTree.isStateTreeNode)(thing) && 'removeView' in thing && 'addView' in thing && 'views' in thing;
}

function isSessionModel(thing) {
  return (0, _typeof2.default)(thing) === 'object' && thing !== null && 'rpcManager' in thing && 'configuration' in thing;
}
/** abstract interface for a session allows editing configurations */


function isSessionModelWithConfigEditing(thing) {
  return isSessionModel(thing) && 'editConfiguration' in thing;
}
/** abstract interface for a session allows adding tracks */


function isSessionWithAddTracks(thing) {
  return isSessionModel(thing) && 'addTrackConf' in thing;
}

function isSessionModelWithWidgets(thing) {
  return isSessionModel(thing) && 'widgets' in thing;
}

function isSessionWithSessionPlugins(thing) {
  return isSessionModel(thing) && 'sessionPlugins' in thing;
}
/** abstract interface for a session that manages a global selection */


function isSelectionContainer(thing) {
  return (0, _typeof2.default)(thing) === 'object' && thing !== null && 'selection' in thing && 'setSelection' in thing;
}
/** minimum interface that all view state models must implement */


function isViewModel(thing) {
  return (0, _typeof2.default)(thing) === 'object' && thing !== null && 'width' in thing && 'setWidth' in thing;
}

function isTrackModel(thing) {
  return (0, _typeof2.default)(thing) === 'object' && thing !== null && 'configuration' in thing && // @ts-ignore
  thing.configuration.trackId;
}

function isDisplayModel(thing) {
  return (0, _typeof2.default)(thing) === 'object' && thing !== null && 'configuration' in thing && // @ts-ignore
  thing.configuration.displayId;
}

function isTrackViewModel(thing) {
  return (0, _typeof2.default)(thing) === 'object' && thing !== null && 'showTrack' in thing && 'hideTrack' in thing;
}
/** minimum interface for the root MST model of a JBrowse app */


function isAppRootModel(thing) {
  return (0, _typeof2.default)(thing) === 'object' && thing !== null && 'isAssemblyEditing' in thing && 'findAppropriateInternetAccount' in thing;
}
/** a root model that manages global menus */


function isAbstractMenuManager(thing) {
  return (0, _typeof2.default)(thing) === 'object' && thing !== null && 'appendMenu' in thing && 'appendToSubMenu' in thing;
} // Empty interfaces required by mobx-state-tree
// See https://mobx-state-tree.js.org/tips/typescript#using-a-mst-type-at-design-time

/* eslint-disable @typescript-eslint/no-empty-interface */


function isUriLocation(location) {
  return (0, _typeof2.default)(location) === 'object' && location !== null && 'locationType' in location && 'uri' in location;
}

var AuthNeededError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(AuthNeededError, _Error);

  var _super = _createSuper(AuthNeededError);

  function AuthNeededError(message, location) {
    var _this;

    (0, _classCallCheck2.default)(this, AuthNeededError);
    _this = _super.call(this, message);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "location", void 0);
    _this.location = location;
    _this.name = 'AuthNeededError';
    Object.setPrototypeOf((0, _assertThisInitialized2.default)(_this), AuthNeededError.prototype);
    return _this;
  }

  return AuthNeededError;
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.AuthNeededError = AuthNeededError;

var RetryError = /*#__PURE__*/function (_Error2) {
  (0, _inherits2.default)(RetryError, _Error2);

  var _super2 = _createSuper(RetryError);

  function RetryError(message, internetAccountId) {
    var _this2;

    (0, _classCallCheck2.default)(this, RetryError);
    _this2 = _super2.call(this, message);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "internetAccountId", void 0);
    _this2.message = message;
    _this2.internetAccountId = internetAccountId;
    _this2.name = 'RetryError';
    return _this2;
  }

  return RetryError;
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.RetryError = RetryError;

function isAuthNeededException(exception) {
  return (// DOMException
    exception.name === 'AuthNeededError' || exception.location !== undefined
  );
}

function isRetryException(exception) {
  return (// DOMException
    exception.name === 'RetryError' || exception.internetAccountId !== undefined
  );
}